import { put, SagaGenerator, select, takeLatest } from "typed-redux-saga";

import { ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";

import { setFilterByKategorie } from "../../../app/slices/textbausteine/reducers";
import { removeDataHolder } from "../../../app/actions";

export function* reloadOnFilterChangeSaga(): SagaGenerator<void> {
	yield* takeLatest(setFilterByKategorie.match, function* (action) {
		const activityId = action.payload.activityId;
		const activity = yield* select(ActivitySelectors.activityById(activityId));

		if (activity === undefined) {
			return;
		}

		yield* put(
			removeDataHolder({
				activityId,
				defaultDescriptor: activity.descriptor
			})
		);

		yield* put(ActivityActions.reloadData({ activityId }));
	});
}
